@if (paginatedContent) {
  <div class="row">
    <div class="col">
      @if (paginatedContent?.data) {
        <div class="">
          @for (item of paginatedContent.data; track item) {
            <card-list-item-promo
              [content]="item"
              [imageTransformations]="imageTransformations"
              (itemSelected)="onItemSelected($event)">
            </card-list-item-promo>
          }
          <div class="my-3">
            @if (paginatedContent?.meta && paginatedContent.meta.last_page > 1) {
              <frontend-pagination-type-three
                [classes]="'pg-purple justify-content-center'"
                [loading]="loading"
                [meta]="paginatedContent.meta"
                [lastPage]="paginatedContent.meta.last_page"
                [links]="paginatedContent.links"
                (changePage)="doGetPaginatedContent($event)"
                >
              </frontend-pagination-type-three>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
<div class="row">
  @for (item of contentItems; track item) {
    <card-list-item-promo [ngClass]="'col-lg-4'" [content]="item"
      [imageTransformations]="imageTransformations" (itemSelected)="onItemSelected($event)">
    </card-list-item-promo>
  }

</div>
<div class="row">
  @if (contentItemsChunkSize && contentItems?.length > contentItemsChunkSize) {
    <button class="btn btn-link show-more-link" (click)="showMoreOrLess()">
      @if (contentItemsDisplay.length == contentItems.length) {
        <i class="fa-solid fa-angle-up"></i>
      }
      <span *transloco="let t">{{ contentItemsDisplay.length < contentItems.length ? t('common.show_more') : t('common.show_less')}}</span>
      @if (contentItemsDisplay.length < contentItems.length) {
        <i class="fa-solid fa-angle-down"></i>
      }
    </button>
  }
</div>